import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Img from "@insite/mobius/Img";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { Properties } from "csstype";
import parse from "html-react-parser";
import * as React from "react";
import styled, { css } from "styled-components";

const enum fields {
    title = "title",
    description = "description",
    buttonLabel = "buttonLabel",
    buttonLink = "buttonLink",
    buttonVariant = "buttonVariant",
    widgetTextColors = "widgetTextColors",
    widgetBackgroundColor = "widgetBackgroundColor",

    // tile 1
    tile1Background = "tile1Background",
    tile1Icon = "tile1Icon",
    tile1Image = "tile1Image",
    tile1ImageMobile = "tile1ImageMobile",
    tile1ImageLabel = "tile1ImageLabel",
    tile1ImageLabelColor = "tile1ImageLabelColor",
    tile1CategoryLabel = "tile1CategoryLabel",
    tile1DestinationUrl = "tile1DestinationUrl",

    // tile 2
    tile2Background = "tile2Background",
    tile2Icon = "tile2Icon",
    tile2Image = "tile2Image",
    tile2ImageMobile = "tile2ImageMobile",
    tile2ImageLabel = "tile2ImageLabel",
    tile2ImageLabelColor = "tile2ImageLabelColor",
    tile2CategoryLabel = "tile2CategoryLabel",
    tile2DestinationUrl = "tile2DestinationUrl",

    // tile 3
    tile3Background = "tile3Background",
    tile3Icon = "tile3Icon",
    tile3Image = "tile3Image",
    tile3ImageMobile = "tile3ImageMobile",
    tile3ImageLabel = "tile3ImageLabel",
    tile3ImageLabelColor = "tile3ImageLabelColor",
    tile3CategoryLabel = "tile3CategoryLabel",
    tile3DestinationUrl = "tile3DestinationUrl",

    // tile 4
    tile4Background = "tile4Background",
    tile4Icon = "tile4Icon",
    tile4Image = "tile4Image",
    tile4ImageMobile = "tile4ImageMobile",
    tile4ImageLabel = "tile4ImageLabel",
    tile4ImageLabelColor = "tile4ImageLabelColor",
    tile4CategoryLabel = "tile4CategoryLabel",
    tile4DestinationUrl = "tile4DestinationUrl",

    // tile 5
    tile5Background = "tile5Background",
    tile5Icon = "tile5Icon",
    tile5Image = "tile5Image",
    tile5ImageMobile = "tile5ImageMobile",
    tile5ImageLabel = "tile5ImageLabel",
    tile5ImageLabelColor = "tile5ImageLabelColor",
    tile5CategoryLabel = "tile5CategoryLabel",
    tile5DestinationUrl = "tile5DestinationUrl",

    // tile 6
    tile6Background = "tile6Background",
    tile6Icon = "tile6Icon",
    tile6Image = "tile6Image",
    tile6ImageMobile = "tile6ImageMobile",
    tile6ImageLabel = "tile6ImageLabel",
    tile6ImageLabelColor = "tile6ImageLabelColor",
    tile6CategoryLabel = "tile6CategoryLabel",
    tile6DestinationUrl = "tile6DestinationUrl",

    // tile 7
    tile7Background = "tile7Background",
    tile7Icon = "tile7Icon",
    tile7Image = "tile7Image",
    tile7ImageMobile = "tile7ImageMobile",
    tile7ImageLabel = "tile7ImageLabel",
    tile7ImageLabelColor = "tile7ImageLabelColor",
    tile7CategoryLabel = "tile7CategoryLabel",
    tile7DestinationUrl = "tile7DestinationUrl",

    // tile 8
    tile8Background = "tile8Background",
    tile8Icon = "tile8Icon",
    tile8Image = "tile8Image",
    tile8ImageMobile = "tile8ImageMobile",
    tile8ImageLabel = "tile8ImageLabel",
    tile8ImageLabelColor = "tile8ImageLabelColor",
    tile8CategoryLabel = "tile8CategoryLabel",
    tile8DestinationUrl = "tile8DestinationUrl",

    // tile 9
    tile9Background = "tile9Background",
    tile9Icon = "tile9Icon",
    tile9Image = "tile9Image",
    tile9ImageMobile = "tile9ImageMobile",
    tile9ImageLabel = "tile9ImageLabel",
    tile9ImageLabelColor = "tile9ImageLabelColor",
    tile9CategoryLabel = "tile9CategoryLabel",
    tile9DestinationUrl = "tile9DestinationUrl",

    // tile 10
    tile10Background = "tile10Background",
    tile10Icon = "tile10Icon",
    tile10Image = "tile10Image",
    tile10ImageMobile = "tile10ImageMobile",
    tile10ImageLabel = "tile10ImageLabel",
    tile10ImageLabelColor = "tile10ImageLabelColor",
    tile10CategoryLabel = "tile10CategoryLabel",
    tile10DestinationUrl = "tile10DestinationUrl",

    // tile 11
    tile11Background = "tile11Background",
    tile11Icon = "tile11Icon",
    tile11Image = "tile11Image",
    tile11ImageMobile = "tile11ImageMobile",
    tile11ImageLabel = "tile11ImageLabel",
    tile11ImageLabelColor = "tile11ImageLabelColor",
    tile11CategoryLabel = "tile11CategoryLabel",
    tile11DestinationUrl = "tile11DestinationUrl",

    // tile 12
    tile12Background = "tile12Background",
    tile12Icon = "tile12Icon",
    tile12Image = "tile12Image",
    tile12ImageMobile = "tile12ImageMobile",
    tile12ImageLabel = "tile12ImageLabel",
    tile12ImageLabelColor = "tile12ImageLabelColor",
    tile12CategoryLabel = "tile12CategoryLabel",
    tile12DestinationUrl = "tile12DestinationUrl",

    // tile 13
    tile13Background = "tile13Background",
    tile13Icon = "tile13Icon",
    tile13Image = "tile13Image",
    tile13ImageMobile = "tile13ImageMobile",
    tile13ImageLabel = "tile13ImageLabel",
    tile13ImageLabelColor = "tile13ImageLabelColor",
    tile13CategoryLabel = "tile13CategoryLabel",
    tile13DestinationUrl = "tile13DestinationUrl",

    // tile 14
    tile14Background = "tile14Background",
    tile14Icon = "tile14Icon",
    tile14Image = "tile14Image",
    tile14ImageMobile = "tile14ImageMobile",
    tile14ImageLabel = "tile14ImageLabel",
    tile14ImageLabelColor = "tile14ImageLabelColor",
    tile14CategoryLabel = "tile14CategoryLabel",
    tile14DestinationUrl = "tile14DestinationUrl",

    // tile 15
    tile15Background = "tile15Background",
    tile15Icon = "tile15Icon",
    tile15Image = "tile15Image",
    tile15ImageMobile = "tile15ImageMobile",
    tile15ImageLabel = "tile15ImageLabel",
    tile15ImageLabelColor = "tile15ImageLabelColor",
    tile15CategoryLabel = "tile15CategoryLabel",
    tile15DestinationUrl = "tile15DestinationUrl",

    // tile 16
    tile16Background = "tile16Background",
    tile16Icon = "tile16Icon",
    tile16Image = "tile16Image",
    tile16ImageMobile = "tile16ImageMobile",
    tile16ImageLabel = "tile16ImageLabel",
    tile16ImageLabelColor = "tile16ImageLabelColor",
    tile16CategoryLabel = "tile16CategoryLabel",
    tile16DestinationUrl = "tile16DestinationUrl",

    // tile 17
    tile17Background = "tile17Background",
    tile17Icon = "tile17Icon",
    tile17Image = "tile17Image",
    tile17ImageMobile = "tile17ImageMobile",
    tile17ImageLabel = "tile17ImageLabel",
    tile17ImageLabelColor = "tile17ImageLabelColor",
    tile17CategoryLabel = "tile17CategoryLabel",
    tile17DestinationUrl = "tile17DestinationUrl",

    // tile 18
    tile18Background = "tile18Background",
    tile18Icon = "tile18Icon",
    tile18Image = "tile18Image",
    tile18ImageMobile = "tile18ImageMobile",
    tile18ImageLabel = "tile18ImageLabel",
    tile18ImageLabelColor = "tile18ImageLabelColor",
    tile18CategoryLabel = "tile18CategoryLabel",
    tile18DestinationUrl = "tile18DestinationUrl",
}

interface Props extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.description]: string;
        [fields.buttonLabel]: string;
        [fields.buttonLink]: LinkFieldValue;
        [fields.buttonVariant]: "primary" | "secondary" | "tertiary";
        [fields.widgetTextColors]: string;
        [fields.widgetBackgroundColor]: string;

        // tile 1
        [fields.tile1Background]: "image" | "icon";
        [fields.tile1Icon]: string;
        [fields.tile1Image]: string;
        [fields.tile1ImageMobile]: string;
        [fields.tile1ImageLabel]: string;
        [fields.tile1ImageLabelColor]: string;
        [fields.tile1CategoryLabel]: string;
        [fields.tile1DestinationUrl]: LinkFieldValue;

        // tile 2
        [fields.tile2Background]: "image" | "icon";
        [fields.tile2Icon]: string;
        [fields.tile2Image]: string;
        [fields.tile2ImageMobile]: string;
        [fields.tile2ImageLabel]: string;
        [fields.tile2ImageLabelColor]: string;
        [fields.tile2CategoryLabel]: string;
        [fields.tile2DestinationUrl]: LinkFieldValue;

        // tile 3
        [fields.tile3Background]: "image" | "icon";
        [fields.tile3Icon]: string;
        [fields.tile3Image]: string;
        [fields.tile3ImageMobile]: string;
        [fields.tile3ImageLabel]: string;
        [fields.tile3ImageLabelColor]: string;
        [fields.tile3CategoryLabel]: string;
        [fields.tile3DestinationUrl]: LinkFieldValue;

        // tile 4
        [fields.tile4Background]: "image" | "icon";
        [fields.tile4Icon]: string;
        [fields.tile4Image]: string;
        [fields.tile4ImageMobile]: string;
        [fields.tile4ImageLabel]: string;
        [fields.tile4ImageLabelColor]: string;
        [fields.tile4CategoryLabel]: string;
        [fields.tile4DestinationUrl]: LinkFieldValue;

        // tile 5
        [fields.tile5Background]: "image" | "icon";
        [fields.tile5Icon]: string;
        [fields.tile5Image]: string;
        [fields.tile5ImageMobile]: string;
        [fields.tile5ImageLabel]: string;
        [fields.tile5ImageLabelColor]: string;
        [fields.tile5CategoryLabel]: string;
        [fields.tile5DestinationUrl]: LinkFieldValue;

        // tile 6
        [fields.tile6Background]: "image" | "icon";
        [fields.tile6Icon]: string;
        [fields.tile6Image]: string;
        [fields.tile6ImageMobile]: string;
        [fields.tile6ImageLabel]: string;
        [fields.tile6ImageLabelColor]: string;
        [fields.tile6CategoryLabel]: string;
        [fields.tile6DestinationUrl]: LinkFieldValue;

        // tile 7
        [fields.tile7Background]: "image" | "icon";
        [fields.tile7Icon]: string;
        [fields.tile7Image]: string;
        [fields.tile7ImageMobile]: string;
        [fields.tile7ImageLabel]: string;
        [fields.tile7ImageLabelColor]: string;
        [fields.tile7CategoryLabel]: string;
        [fields.tile7DestinationUrl]: LinkFieldValue;

        // tile 8
        [fields.tile8Background]: "image" | "icon";
        [fields.tile8Icon]: string;
        [fields.tile8Image]: string;
        [fields.tile8ImageMobile]: string;
        [fields.tile8ImageLabel]: string;
        [fields.tile8ImageLabelColor]: string;
        [fields.tile8CategoryLabel]: string;
        [fields.tile8DestinationUrl]: LinkFieldValue;

        // tile 9
        [fields.tile9Background]: "image" | "icon";
        [fields.tile9Icon]: string;
        [fields.tile9Image]: string;
        [fields.tile9ImageMobile]: string;
        [fields.tile9ImageLabel]: string;
        [fields.tile9ImageLabelColor]: string;
        [fields.tile9CategoryLabel]: string;
        [fields.tile9DestinationUrl]: LinkFieldValue;

        // tile 10
        [fields.tile10Background]: "image" | "icon";
        [fields.tile10Icon]: string;
        [fields.tile10Image]: string;
        [fields.tile10ImageMobile]: string;
        [fields.tile10ImageLabel]: string;
        [fields.tile10ImageLabelColor]: string;
        [fields.tile10CategoryLabel]: string;
        [fields.tile10DestinationUrl]: LinkFieldValue;

        // tile 11
        [fields.tile11Background]: "image" | "icon";
        [fields.tile11Icon]: string;
        [fields.tile11Image]: string;
        [fields.tile11ImageMobile]: string;
        [fields.tile11ImageLabel]: string;
        [fields.tile11ImageLabelColor]: string;
        [fields.tile11CategoryLabel]: string;
        [fields.tile11DestinationUrl]: LinkFieldValue;

        // tile 12
        [fields.tile12Background]: "image" | "icon";
        [fields.tile12Icon]: string;
        [fields.tile12Image]: string;
        [fields.tile12ImageMobile]: string;
        [fields.tile12ImageLabel]: string;
        [fields.tile12ImageLabelColor]: string;
        [fields.tile12CategoryLabel]: string;
        [fields.tile12DestinationUrl]: LinkFieldValue;

        // tile 13
        [fields.tile13Background]: "image" | "icon";
        [fields.tile13Icon]: string;
        [fields.tile13Image]: string;
        [fields.tile13ImageMobile]: string;
        [fields.tile13ImageLabel]: string;
        [fields.tile13ImageLabelColor]: string;
        [fields.tile13CategoryLabel]: string;
        [fields.tile13DestinationUrl]: LinkFieldValue;

        // tile 14
        [fields.tile14Background]: "image" | "icon";
        [fields.tile14Icon]: string;
        [fields.tile14Image]: string;
        [fields.tile14ImageMobile]: string;
        [fields.tile14ImageLabel]: string;
        [fields.tile14ImageLabelColor]: string;
        [fields.tile14CategoryLabel]: string;
        [fields.tile14DestinationUrl]: LinkFieldValue;

        // tile 15
        [fields.tile15Background]: "image" | "icon";
        [fields.tile15Icon]: string;
        [fields.tile15Image]: string;
        [fields.tile15ImageMobile]: string;
        [fields.tile15ImageLabel]: string;
        [fields.tile15ImageLabelColor]: string;
        [fields.tile15CategoryLabel]: string;
        [fields.tile15DestinationUrl]: LinkFieldValue;

        // tile 16
        [fields.tile16Background]: "image" | "icon";
        [fields.tile16Icon]: string;
        [fields.tile16Image]: string;
        [fields.tile16ImageMobile]: string;
        [fields.tile16ImageLabel]: string;
        [fields.tile16ImageLabelColor]: string;
        [fields.tile16CategoryLabel]: string;
        [fields.tile16DestinationUrl]: LinkFieldValue;

        // tile 17
        [fields.tile17Background]: "image" | "icon";
        [fields.tile17Icon]: string;
        [fields.tile17Image]: string;
        [fields.tile17ImageMobile]: string;
        [fields.tile17ImageLabel]: string;
        [fields.tile17ImageLabelColor]: string;
        [fields.tile17CategoryLabel]: string;
        [fields.tile17DestinationUrl]: LinkFieldValue;

        // tile 18
        [fields.tile18Background]: "image" | "icon";
        [fields.tile18Icon]: string;
        [fields.tile18Image]: string;
        [fields.tile18ImageMobile]: string;
        [fields.tile18ImageLabel]: string;
        [fields.tile18ImageLabelColor]: string;
        [fields.tile18CategoryLabel]: string;
        [fields.tile18DestinationUrl]: LinkFieldValue;
    };
}

export interface ShopCategoryStyles {
    asShopCategorySection?: InjectableCss;
}
const StyledSection = styled.section.attrs({ "aria-label": "shop-category" })`
`;
export

    function getUrl(categoryUrl: LinkFieldValue) {
    const { url } = useGetLink(categoryUrl);
    const history = useHistory();
    const { isInShell } = useShellContext();

    const onClick = () => {
        if (!url) {
            return;
        }

        if (url.startsWith("http")) {
            if (isInShell) {
                return;
            }

            window.location.href = url;
        } else {
            history.push(url);
        }
    };

    return url;
}

const ShopCategoryWidget: React.FC<Props> = ({ fields }) => {
    const { isInShell } = useShellContext();
    const history = useHistory();
    const shopCategoryStyles: ShopCategoryStyles = {
        asShopCategorySection: {
            css: css`
                a {
                    background-color: transparent;
                    color: #253746;
                    transition: color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
                    -webkit-text-decoration: none;
                    text-decoration: none;
                    &:hover {
                        -webkit-text-decoration: none;
                        text-decoration: none;
                        color: #c8102e;
                    }
                }
                strong {
                    font-weight: bolder;
                }
                img {
                    border-style: none;
                }
                * {
                    box-sizing: inherit;
                }
                &:after {
                    box-sizing: inherit;
                }
                &:before {
                    box-sizing: inherit;
                }
                p {
                    margin: 0 0 22px;
                }
                h2 {
                    color: #013d54;
                    font-weight: inherit;
                    margin: 0 0 10px;
                    font-weight: 700;
                    line-height: 1.26;
                }
                .as-container {
                    &:after {
                        clear: both;
                        content: "";
                        display: block;
                    }
                    margin: 0 auto;
                    max-width: 1180px;
                    padding-left: 20px;
                    padding-right: 20px;
                    width: 100%;
                }
                .as-btn {
                    display: inline-block;
                    font-size: 16px;
                    letter-spacing: 0.48px;
                    line-height: 1.2;
                    transition: background 0.3s ease, color 0.3s ease;
                    vertical-align: top;
                }
                .as-btn-primary {
                    font-weight: 700;
                }
                .as-category-section {
                    background: rgba(154, 219, 232, 0.42);
                    padding: 41px 0 38px;
                    .as-container {
                        max-width: 1036px;
                    }
                }
                .as-text-center {
                    text-align: center;
                }
                .as-head-box {
                    color: #013d54;
                    letter-spacing: 0.18px;
                    line-height: 1.28;
                    margin: 0 auto 44px;
                    max-width: 710px;
                    padding: 0 5%;
                    h2 {
                        font-size: 32px;
                        font-weight: 500;
                        letter-spacing: 0;
                        margin: 0 0 10px;
                    }
                    p {
                        margin-bottom: 17px;
                    }
                }
                .as-category-list {
                    display: flex;
                    flex-wrap: wrap;
                    margin: 0 -8px;
                }
                .as-category-item {
                    padding: 0 8px 12px;
                    width: 50%;
                    .as-category-holder {
                        background: #fff;
                        border-radius: 30px;
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                        justify-content: center;
                        min-height: 150px;
                        padding: 18px 10px 10px;
                        text-align: center;
                        transition: box-shadow 0.3s ease;
                        background-position: center center;
                        background-repeat: no-repeat;
                        &:hover {
                            box-shadow: 0 6px 6px rgba(0, 42, 83, 0.16);
                        }
                    }
                    .as-category-img {
                        align-items: center;
                        display: flex;
                        height: 55px;
                        justify-content: center;
                        margin: 0 auto 17px;
                        width: 72px;
                    }
                    img {
                        max-height: 100%;
                        max-width: 100%;
                        vertical-align: top;
                    }
                    .as-category-ttl {
                        color: #013d54;
                        display: block;
                        font-size: 15px;
                        font-weight: 700;
                        line-height: 1.26;
                    }
                    .as-category-ttl.cat-img {
                        margin-bottom: -160px;
                    }
                }
                @media (min-width: 768px) {
                    .as-category-section {
                        padding: 75px 0 65px;
                    }
                    .as-head-box {
                        h2 {
                            font-size: 42px;
                        }
                        p {
                            margin: 0 0 22px;
                        }
                    }
                    .as-category-list {
                        margin: 0 -13px;
                    }
                    .as-category-item {
                        padding: 0 19px 27px;
                        width: 33.33%;
                        .as-category-holder {
                            min-height: 200px;
                        }
                        .as-category-img {
                            height: 93px;
                            width: 121px;
                        }
                        .as-category-ttl {
                            font-size: 20px;
                        }
                    }
                }
                @media (min-width: 1024px) {
                    h2 {
                        font-size: 23px;
                    }
                    .as-head-box {
                        line-height: 1.4;
                        margin: 0 auto 48px;
                        padding: 0;
                    }
                    .as-category-item {
                        .as-category-holder {
                            min-height: 227px;
                            padding: 28px 20px 20px;
                        }
                        .as-category-ttl {
                            font-size: 23px;
                        }
                    }
                }
    
                @media only screen and (max-width: 600px) {
                    .as-category-ttl.cat-img {
                        margin-bottom: -105px !important;
                    }
                }
                /* Dynamic image background styles */
                .as-category-holder {
                ${getTileStyle(1, fields.tile1Image)}
                ${getTileStyle(2, fields.tile2Image)}
                ${getTileStyle(3, fields.tile3Image)}
                ${getTileStyle(4, fields.tile4Image)}
                ${getTileStyle(5, fields.tile5Image)}
                ${getTileStyle(6, fields.tile6Image)}
                ${getTileStyle(7, fields.tile7Image)}
                ${getTileStyle(8, fields.tile8Image)}
                ${getTileStyle(9, fields.tile9Image)}
                ${getTileStyle(10, fields.tile10Image)}
                ${getTileStyle(11, fields.tile11Image)}
                ${getTileStyle(12, fields.tile12Image)}
                ${getTileStyle(13, fields.tile13Image)}
                ${getTileStyle(14, fields.tile14Image)}
                ${getTileStyle(15, fields.tile15Image)}
                ${getTileStyle(16, fields.tile16Image)}
                ${getTileStyle(17, fields.tile17Image)}
                ${getTileStyle(18, fields.tile18Image)}
                @media (max-width:767px) {
                    ${getTileStyle(1, fields.tile1ImageMobile)}
                    ${getTileStyle(2, fields.tile2ImageMobile)}
                    ${getTileStyle(3, fields.tile3ImageMobile)}
                    ${getTileStyle(4, fields.tile4ImageMobile)}
                    ${getTileStyle(5, fields.tile5ImageMobile)}
                    ${getTileStyle(6, fields.tile6ImageMobile)}
                    ${getTileStyle(7, fields.tile7ImageMobile)}
                    ${getTileStyle(8, fields.tile8ImageMobile)}
                    ${getTileStyle(9, fields.tile9ImageMobile)}
                    ${getTileStyle(10, fields.tile10ImageMobile)}
                    ${getTileStyle(11, fields.tile11ImageMobile)}
                    ${getTileStyle(12, fields.tile12ImageMobile)}
                    ${getTileStyle(13, fields.tile13ImageMobile)}
                    ${getTileStyle(14, fields.tile14ImageMobile)}
                    ${getTileStyle(15, fields.tile15ImageMobile)}
                    ${getTileStyle(16, fields.tile16ImageMobile)}
                    ${getTileStyle(17, fields.tile17ImageMobile)}
                    ${getTileStyle(18, fields.tile18ImageMobile)}
                }
            }
            `
        }
    };
    const styles = shopCategoryStyles;

    const onClick = (link: string | undefined) => {
        if (!link) {
            return;
        }

        if (link.startsWith("http")) {
            if (isInShell) {
                return;
            }

            window.location.href = link;
        } else {
            history.push(link);
        }
    };

    const buttonUrl = getUrl(fields.buttonLink);
    const catUrl1 = getUrl(fields.tile1DestinationUrl);
    const catUrl2 = getUrl(fields.tile2DestinationUrl);
    const catUrl3 = getUrl(fields.tile3DestinationUrl);
    const catUrl4 = getUrl(fields.tile4DestinationUrl);
    const catUrl5 = getUrl(fields.tile5DestinationUrl);
    const catUrl6 = getUrl(fields.tile6DestinationUrl);
    const catUrl7 = getUrl(fields.tile7DestinationUrl);
    const catUrl8 = getUrl(fields.tile8DestinationUrl);
    const catUrl9 = getUrl(fields.tile9DestinationUrl);
    const catUrl10 = getUrl(fields.tile10DestinationUrl);
    const catUrl11 = getUrl(fields.tile11DestinationUrl);
    const catUrl12 = getUrl(fields.tile12DestinationUrl);
    const catUrl13 = getUrl(fields.tile13DestinationUrl);
    const catUrl14 = getUrl(fields.tile14DestinationUrl);
    const catUrl15 = getUrl(fields.tile15DestinationUrl);
    const catUrl16 = getUrl(fields.tile16DestinationUrl);
    const catUrl17 = getUrl(fields.tile17DestinationUrl);
    const catUrl18 = getUrl(fields.tile18DestinationUrl);

    return (
        <StyledWrapper {...styles.asShopCategorySection} >
            <section className="as-category-section" style={{ background: `${fields.widgetBackgroundColor}` }}>
                <div className="as-container">
                    <div className="as-head-box as-text-center">
                        <h2 style={{ color: `${fields.widgetTextColors}` }}>{fields.title}</h2>
                        <p style={{ color: `${fields.widgetTextColors}` }}>
                            {parse(fields.description, parserOptions)}
                        </p>
                       {((fields.buttonLabel && fields.buttonLabel.trim()) || fields.buttonLink?.value || buttonUrl) && <Button
                            className="as-btn as-btn-primary"
                            variant={fields.buttonVariant}
                            onClick={() => onClick(buttonUrl)}
                        >
                            {fields.buttonLabel || fields.buttonLink?.value || buttonUrl}
                        </Button>}
                    </div>

                    {/* tile 1 */}
                    <div className="as-category-list">
                        {fields.tile1Background === "image" && catUrl1 && (
                            <div className="as-category-item">
                                <a href={catUrl1} className="as-category-holder tile1Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile1ImageLabelColor}` }}>{fields.tile1ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile1Background === "icon" && catUrl1 && (
                            <div className="as-category-item">
                                <a href={catUrl1} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile1Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile1CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 2 */}
                        {fields.tile2Background === "image" && catUrl2 && (
                            <div className="as-category-item">
                                <a href={catUrl2} className="as-category-holder tile2Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile2ImageLabelColor}` }}>{fields.tile2ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile2Background === "icon" && catUrl2 && (
                            <div className="as-category-item">
                                <a href={catUrl2} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile2Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile2CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 3 */}
                        {fields.tile3Background === "image" && catUrl3 && (
                            <div className="as-category-item">
                                <a href={catUrl3} className="as-category-holder tile3Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile3ImageLabelColor}` }}>{fields.tile3ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile3Background === "icon" && catUrl3 && (
                            <div className="as-category-item">
                                <a href={catUrl3} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile3Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile3CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 4 */}
                        {fields.tile4Background === "image" && catUrl4 && (
                            <div className="as-category-item">
                                <a href={catUrl4} className="as-category-holder tile4Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile4ImageLabelColor}` }}>{fields.tile4ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile4Background === "icon" && catUrl4 && (
                            <div className="as-category-item">
                                <a href={catUrl4} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile4Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile4CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 5 */}
                        {fields.tile5Background === "image" && catUrl5 && (
                            <div className="as-category-item">
                                <a href={catUrl5} className="as-category-holder tile5Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile5ImageLabelColor}` }}>{fields.tile5ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile5Background === "icon" && catUrl5 && (
                            <div className="as-category-item">
                                <a href={catUrl5} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile5Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile5CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 6 */}
                        {fields.tile6Background === "image" && catUrl6 && (
                            <div className="as-category-item">
                                <a href={catUrl6} className="as-category-holder tile6Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile6ImageLabelColor}` }}>{fields.tile6ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile6Background === "icon" && catUrl6 && (
                            <div className="as-category-item">
                                <a href={catUrl6} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile6Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile6CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 7 */}
                        {fields.tile7Background === "image" && catUrl7 && (
                            <div className="as-category-item">
                                <a href={catUrl7} className="as-category-holder tile7Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile7ImageLabelColor}` }}>{fields.tile7ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile7Background === "icon" && catUrl7 && (
                            <div className="as-category-item">
                                <a href={catUrl7} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile7Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile7CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 8 */}
                        {fields.tile8Background === "image" && catUrl8 && (
                            <div className="as-category-item">
                                <a href={catUrl8} className="as-category-holder tile8Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile8ImageLabelColor}` }}>{fields.tile8ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile8Background === "icon" && catUrl8 && (
                            <div className="as-category-item">
                                <a href={catUrl8} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile8Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile8CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 9 */}
                        {fields.tile9Background === "image" && catUrl9 && (
                            <div className="as-category-item">
                                <a href={catUrl9} className="as-category-holder tile9Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile9ImageLabelColor}` }}>{fields.tile9ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile9Background === "icon" && catUrl9 && (
                            <div className="as-category-item">
                                <a href={catUrl9} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile9Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile9CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 10 */}
                        {fields.tile10Background === "image" && catUrl10 && (
                            <div className="as-category-item">
                                <a href={catUrl10} className="as-category-holder tile10Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile10ImageLabelColor}` }}>{fields.tile10ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile10Background === "icon" && catUrl10 && (
                            <div className="as-category-item">
                                <a href={catUrl10} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile10Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile10CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 11 */}
                        {fields.tile11Background === "image" && catUrl11 && (
                            <div className="as-category-item">
                                <a href={catUrl11} className="as-category-holder tile11Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile11ImageLabelColor}` }}>{fields.tile11ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile11Background === "icon" && catUrl11 && (
                            <div className="as-category-item">
                                <a href={catUrl11} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile11Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile11CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 12 */}
                        {fields.tile12Background === "image" && catUrl12 && (
                            <div className="as-category-item">
                                <a href={catUrl12} className="as-category-holder tile12Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile12ImageLabelColor}` }}>{fields.tile12ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile12Background === "icon" && catUrl12 && (
                            <div className="as-category-item">
                                <a href={catUrl12} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile12Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile12CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 13 */}
                        {fields.tile13Background === "image" && catUrl13 && (
                            <div className="as-category-item">
                                <a href={catUrl13} className="as-category-holder tile13Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile13ImageLabelColor}` }}>{fields.tile13ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile13Background === "icon" && catUrl13 && (
                            <div className="as-category-item">
                                <a href={catUrl13} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile13Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile13CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 14 */}
                        {fields.tile14Background === "image" && catUrl14 && (
                            <div className="as-category-item">
                                <a href={catUrl14} className="as-category-holder tile14Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile14ImageLabelColor}` }}>{fields.tile14ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile14Background === "icon" && catUrl14 && (
                            <div className="as-category-item">
                                <a href={catUrl14} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile14Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile14CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 15 */}
                        {fields.tile15Background === "image" && catUrl15 && (
                            <div className="as-category-item">
                                <a href={catUrl15} className="as-category-holder tile15Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile15ImageLabelColor}` }}>{fields.tile15ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile15Background === "icon" && catUrl15 && (
                            <div className="as-category-item">
                                <a href={catUrl15} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile15Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile15CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 16 */}
                        {fields.tile16Background === "image" && catUrl16 && (
                            <div className="as-category-item">
                                <a href={catUrl16} className="as-category-holder tile16Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile16ImageLabelColor}` }}>{fields.tile16ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile16Background === "icon" && catUrl16 && (
                            <div className="as-category-item">
                                <a href={catUrl16} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile16Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile16CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 17 */}
                        {fields.tile17Background === "image" && catUrl17 && (
                            <div className="as-category-item">
                                <a href={catUrl17} className="as-category-holder tile17Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile17ImageLabelColor}` }}>{fields.tile17ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile17Background === "icon" && catUrl17 && (
                            <div className="as-category-item">
                                <a href={catUrl17} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile17Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile17CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}

                        {/* tile 18 */}
                        {fields.tile18Background === "image" && catUrl18 && (
                            <div className="as-category-item">
                                <a href={catUrl18} className="as-category-holder tile18Image">
                                    <strong className="as-category-ttl cat-img" style={{ color: `${fields.tile18ImageLabelColor}` }}>{fields.tile18ImageLabel}</strong>
                                </a>
                            </div>
                        )}

                        {fields.tile18Background === "icon" && catUrl18 && (
                            <div className="as-category-item">
                                <a href={catUrl18} className="as-category-holder">
                                    <div className="as-category-img">
                                        <Img src={fields.tile18Icon} alt="image description" />
                                    </div>
                                    <strong className="as-category-ttl" style={{ color: `${fields.widgetTextColors}` }}>
                                        {fields.tile18CategoryLabel}
                                    </strong>
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </StyledWrapper >
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.title,
            displayName: "Title",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the widget title",
            isRequired: false,
        },
        {
            name: fields.description,
            displayName: "Description",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the widget description",
            isRequired: false,
        },
        {
            name: fields.buttonLabel,
            displayName: "Button Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the button label",
            isRequired: false,
        },
        {
            name: fields.buttonLink,
            displayName: "Button Link",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Select the button link",
            isRequired: false,
        },
        {
            name: fields.buttonVariant,
            displayName: "Button Variant",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Primary", value: "primary" },
                { displayName: "Secondary", value: "secondary" },
                { displayName: "Tertiary", value: "tertiary" },
            ],
            hideEmptyOption: true,
            defaultValue: "primary",
            fieldType: "General",
        },
        {
            name: fields.widgetTextColors,
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            displayName: "Widget text color",
            defaultValue: "",
        },
        {
            name: fields.widgetBackgroundColor,
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            displayName: "Widget background color",
            defaultValue: "",
        },

        // tile 1
        {
            name: fields.tile1Background,
            fieldType: "General",
            displayName: "Tile 1 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile1Image,
            displayName: "Tile 1 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile1ImageMobile,
            displayName: "Tile 1 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile1ImageLabel,
            displayName: "Tile 1 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile1ImageLabelColor,
            displayName: "Tile 1 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile1Icon,
            displayName: "Tile 1 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 1 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile1Background === "icon",
        },
        {
            name: fields.tile1CategoryLabel,
            displayName: "Tile 1 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 1 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile1Background === "icon",
        },
        {
            name: fields.tile1DestinationUrl,
            displayName: "Tile 1 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 1 destination Url",
            isRequired: false,
        },

        // tile 2
        {
            name: fields.tile2Background,
            fieldType: "General",
            displayName: "Tile 2 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile2Image,
            displayName: "Tile 2 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile2Background === "image",
        },
        {
            name: fields.tile2ImageMobile,
            displayName: "Tile 2 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile2ImageLabel,
            displayName: "Tile 2 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile2Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile2ImageLabelColor,
            displayName: "Tile 2 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile2Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile2Icon,
            displayName: "Tile 2 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 2 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile2Background === "icon",
        },
        {
            name: fields.tile2CategoryLabel,
            displayName: "Tile 2 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 2 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile2Background === "icon",
        },
        {
            name: fields.tile2DestinationUrl,
            displayName: "Tile 2 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 2 destination Url",
            isRequired: false,
        },

        // tile 3
        {
            name: fields.tile3Background,
            fieldType: "General",
            displayName: "Tile 3 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile3Image,
            displayName: "Tile 3 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile3Background === "image",
        },
        {
            name: fields.tile3ImageMobile,
            displayName: "Tile 3 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile3ImageLabel,
            displayName: "Tile 3 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile3Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile3ImageLabelColor,
            displayName: "Tile 3 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile3Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile3Icon,
            displayName: "Tile 3 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 3 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile3Background === "icon",
        },
        {
            name: fields.tile3CategoryLabel,
            displayName: "Tile 3 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 3 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile3Background === "icon",
        },
        {
            name: fields.tile3DestinationUrl,
            displayName: "Tile 3 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 3 destination Url",
            isRequired: false,
        },

        // tile 4
        {
            name: fields.tile4Background,
            fieldType: "General",
            displayName: "Tile 4 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile4Image,
            displayName: "Tile 4 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile4Background === "image",
        },
        {
            name: fields.tile4ImageMobile,
            displayName: "Tile 4 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile4ImageLabel,
            displayName: "Tile 4 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile4Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile4ImageLabelColor,
            displayName: "Tile 4 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile4Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile4Icon,
            displayName: "Tile 4 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 4 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile4Background === "icon",
        },
        {
            name: fields.tile4CategoryLabel,
            displayName: "Tile 4 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 4 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile4Background === "icon",
        },
        {
            name: fields.tile4DestinationUrl,
            displayName: "Tile 4 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 4 destination Url",
            isRequired: false,
        },

        // tile 5
        {
            name: fields.tile5Background,
            fieldType: "General",
            displayName: "Tile 5 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile5Image,
            displayName: "Tile 5 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile5Background === "image",
        },
        {
            name: fields.tile5ImageMobile,
            displayName: "Tile 5 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile5ImageLabel,
            displayName: "Tile 5 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile5Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile5ImageLabelColor,
            displayName: "Tile 5 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile5Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile5Icon,
            displayName: "Tile 5 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 5 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile5Background === "icon",
        },
        {
            name: fields.tile5CategoryLabel,
            displayName: "Tile 5 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 5 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile5Background === "icon",
        },
        {
            name: fields.tile5DestinationUrl,
            displayName: "Tile 5 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 5 destination Url",
            isRequired: false,
        },

        // tile 6
        {
            name: fields.tile6Background,
            fieldType: "General",
            displayName: "Tile 6 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile6Image,
            displayName: "Tile 6 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile6Background === "image",
        },
        {
            name: fields.tile6ImageMobile,
            displayName: "Tile 6 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile6ImageLabel,
            displayName: "Tile 6 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile6Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile6ImageLabelColor,
            displayName: "Tile 6 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile6Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile6Icon,
            displayName: "Tile 6 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 6 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile6Background === "icon",
        },
        {
            name: fields.tile6CategoryLabel,
            displayName: "Tile 6 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 6 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile6Background === "icon",
        },
        {
            name: fields.tile6DestinationUrl,
            displayName: "Tile 6 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 6 destination Url",
            isRequired: false,
        },

        // tile 7
        {
            name: fields.tile7Background,
            fieldType: "General",
            displayName: "Tile 7 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile7Image,
            displayName: "Tile 7 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile7Background === "image",
        },
        {
            name: fields.tile7ImageMobile,
            displayName: "Tile 7 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile7ImageLabel,
            displayName: "Tile 7 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile7Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile7ImageLabelColor,
            displayName: "Tile 7 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile7Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile7Icon,
            displayName: "Tile 7 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 7 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile7Background === "icon",
        },
        {
            name: fields.tile7CategoryLabel,
            displayName: "Tile 7 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 7 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile7Background === "icon",
        },
        {
            name: fields.tile7DestinationUrl,
            displayName: "Tile 7 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 7 destination Url",
            isRequired: false,
        },

        // tile 8
        {
            name: fields.tile8Background,
            fieldType: "General",
            displayName: "Tile 8 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile8Image,
            displayName: "Tile 8 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile8Background === "image",
        },
        {
            name: fields.tile8ImageMobile,
            displayName: "Tile 8 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile8ImageLabel,
            displayName: "Tile 8 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile8Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile8ImageLabelColor,
            displayName: "Tile 8 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile8Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile8Icon,
            displayName: "Tile 8 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 8 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile8Background === "icon",
        },
        {
            name: fields.tile8CategoryLabel,
            displayName: "Tile 8 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 8 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile8Background === "icon",
        },
        {
            name: fields.tile8DestinationUrl,
            displayName: "Tile 8 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 8 destination Url",
            isRequired: false,
        },

        // tile 9
        {
            name: fields.tile9Background,
            fieldType: "General",
            displayName: "Tile 9 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile9Image,
            displayName: "Tile 9 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile9Background === "image",
        },
        {
            name: fields.tile9ImageMobile,
            displayName: "Tile 9 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile9ImageLabel,
            displayName: "Tile 9 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile9Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile9ImageLabelColor,
            displayName: "Tile 9 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile9Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile9Icon,
            displayName: "Tile 9 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 9 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile9Background === "icon",
        },
        {
            name: fields.tile9CategoryLabel,
            displayName: "Tile 9 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 9 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile9Background === "icon",
        },
        {
            name: fields.tile9DestinationUrl,
            displayName: "Tile 9 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 9 destination Url",
            isRequired: false,
        },

        // tile 10
        {
            name: fields.tile10Background,
            fieldType: "General",
            displayName: "Tile 10 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile10Image,
            displayName: "Tile 10 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile10Background === "image",
        },
        {
            name: fields.tile10ImageMobile,
            displayName: "Tile 10 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile10ImageLabel,
            displayName: "Tile 10 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile10Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile10ImageLabelColor,
            displayName: "Tile 10 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile10Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile10Icon,
            displayName: "Tile 10 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 10 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile10Background === "icon",
        },
        {
            name: fields.tile10CategoryLabel,
            displayName: "Tile 10 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 10 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile10Background === "icon",
        },
        {
            name: fields.tile10DestinationUrl,
            displayName: "Tile 10 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 10 destination Url",
            isRequired: false,
        },

        // tile 11
        {
            name: fields.tile11Background,
            fieldType: "General",
            displayName: "Tile 11 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile11Image,
            displayName: "Tile 11 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile11Background === "image",
        },
        {
            name: fields.tile11ImageMobile,
            displayName: "Tile 11 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile11ImageLabel,
            displayName: "Tile 11 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile11Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile11ImageLabelColor,
            displayName: "Tile 11 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile11Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile11Icon,
            displayName: "Tile 11 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 11 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile11Background === "icon",
        },
        {
            name: fields.tile11CategoryLabel,
            displayName: "Tile 11 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 11 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile11Background === "icon",
        },
        {
            name: fields.tile11DestinationUrl,
            displayName: "Tile 11 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 11 destination Url",
            isRequired: false,
        },

        // tile 12
        {
            name: fields.tile12Background,
            fieldType: "General",
            displayName: "Tile 12 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile12Image,
            displayName: "Tile 12 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile12Background === "image",
        },
        {
            name: fields.tile12ImageMobile,
            displayName: "Tile 12 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile12ImageLabel,
            displayName: "Tile 12 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile12Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile12ImageLabelColor,
            displayName: "Tile 12 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile12Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile12Icon,
            displayName: "Tile 12 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 12 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile12Background === "icon",
        },
        {
            name: fields.tile12CategoryLabel,
            displayName: "Tile 12 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 12 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile12Background === "icon",
        },
        {
            name: fields.tile12DestinationUrl,
            displayName: "Tile 12 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 12 destination Url",
            isRequired: false,
        },

        // tile 13
        {
            name: fields.tile13Background,
            fieldType: "General",
            displayName: "Tile 13 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile13Image,
            displayName: "Tile 13 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile13Background === "image",
        },
        {
            name: fields.tile13ImageMobile,
            displayName: "Tile 13 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile13ImageLabel,
            displayName: "Tile 13 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile13Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile13ImageLabelColor,
            displayName: "Tile 13 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile13Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile13Icon,
            displayName: "Tile 13 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 13 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile13Background === "icon",
        },
        {
            name: fields.tile13CategoryLabel,
            displayName: "Tile 13 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 13 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile13Background === "icon",
        },
        {
            name: fields.tile13DestinationUrl,
            displayName: "Tile 13 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 13 destination Url",
            isRequired: false,
        },

        // tile 14
        {
            name: fields.tile14Background,
            fieldType: "General",
            displayName: "Tile 14 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile14Image,
            displayName: "Tile 14 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile14Background === "image",
        },
        {
            name: fields.tile14ImageMobile,
            displayName: "Tile 14 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile14ImageLabel,
            displayName: "Tile 14 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile14Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile14ImageLabelColor,
            displayName: "Tile 14 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile14Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile14Icon,
            displayName: "Tile 14 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 14 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile14Background === "icon",
        },
        {
            name: fields.tile14CategoryLabel,
            displayName: "Tile 14 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 14 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile14Background === "icon",
        },
        {
            name: fields.tile14DestinationUrl,
            displayName: "Tile 14 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 14 destination Url",
            isRequired: false,
        },

        // tile 15
        {
            name: fields.tile15Background,
            fieldType: "General",
            displayName: "Tile 15 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile15Image,
            displayName: "Tile 15 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile15Background === "image",
        },
        {
            name: fields.tile15ImageMobile,
            displayName: "Tile 15 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile15ImageLabel,
            displayName: "Tile 15 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile15Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile15ImageLabelColor,
            displayName: "Tile 15 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile15Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile15Icon,
            displayName: "Tile 15 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 15 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile15Background === "icon",
        },
        {
            name: fields.tile15CategoryLabel,
            displayName: "Tile 15 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 15 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile15Background === "icon",
        },
        {
            name: fields.tile15DestinationUrl,
            displayName: "Tile 15 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 15 destination Url",
            isRequired: false,
        },

        // tile 16
        {
            name: fields.tile16Background,
            fieldType: "General",
            displayName: "Tile 16 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile16Image,
            displayName: "Tile 16 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile16Background === "image",
        },
        {
            name: fields.tile16ImageMobile,
            displayName: "Tile 16 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile16ImageLabel,
            displayName: "Tile 16 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile16Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile16ImageLabelColor,
            displayName: "Tile 16 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile16Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile16Icon,
            displayName: "Tile 16 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 16 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile16Background === "icon",
        },
        {
            name: fields.tile16CategoryLabel,
            displayName: "Tile 16 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 16 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile16Background === "icon",
        },
        {
            name: fields.tile16DestinationUrl,
            displayName: "Tile 16 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 16 destination Url",
            isRequired: false,
        },

        // tile 17
        {
            name: fields.tile17Background,
            fieldType: "General",
            displayName: "Tile 17 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile17Image,
            displayName: "Tile 17 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile17Background === "image",
        },
        {
            name: fields.tile17ImageMobile,
            displayName: "Tile 17 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile17ImageLabel,
            displayName: "Tile 17 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile17Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile17ImageLabelColor,
            displayName: "Tile 17 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile17Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile17Icon,
            displayName: "Tile 17 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 17 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile17Background === "icon",
        },
        {
            name: fields.tile17CategoryLabel,
            displayName: "Tile 17 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 17 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile17Background === "icon",
        },
        {
            name: fields.tile17DestinationUrl,
            displayName: "Tile 17 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 17 destination Url",
            isRequired: false,
        },

        // tile 18
        {
            name: fields.tile18Background,
            fieldType: "General",
            displayName: "Tile 18 Background",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Image", value: "image" },
                { displayName: "Icon", value: "icon" },
            ],
            defaultValue: "image",
            hideEmptyOption: true,
        },
        {
            name: fields.tile18Image,
            displayName: "Tile 18 Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile18Background === "image",
        },
        {
            name: fields.tile18ImageMobile,
            displayName: "Tile 18 Mobile Image",
            fieldType: "General",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile1Background === "image",
        },
        {
            name: fields.tile18ImageLabel,
            displayName: "Tile 18 Image Label",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile18Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile18ImageLabelColor,
            displayName: "Tile 18 Image Label Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isVisible: widget => widget.fields.tile18Background === "image",
            isRequired: false,
        },
        {
            name: fields.tile18Icon,
            displayName: "Tile 18 Icon",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "select the tile 18 Icon",
            isRequired: false,
            isVisible: widget => widget.fields.tile18Background === "icon",
        },
        {
            name: fields.tile18CategoryLabel,
            displayName: "Tile 18 Category Label",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter the tile 18 label",
            isRequired: false,
            isVisible: widget => widget.fields.tile18Background === "icon",
        },
        {
            name: fields.tile18DestinationUrl,
            displayName: "Tile 18 Destination Url",
            editorTemplate: "LinkField",
            defaultValue: { type: "Page", value: "" },
            fieldType: "General",
            tooltip: "Enter the tile 18 destination Url",
            isRequired: false,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: ShopCategoryWidget,
    definition,
};

export default widgetModule;

function getTileStyle(number: number, tileImage: string): import("styled-components").SimpleInterpolation {
    if (!tileImage) {
        return '';
    }
    return `&.tile${number}Image {
                background-image: url(${tileImage});
            }`
}
